export const EnterFlowFeature = {
  MULTIPLE_ENTRIES: 'MULTIPLE_ENTRIES',
  MULTIPLE_DRAWS: 'MULTIPLE_DRAWS',
  BOOST_OR_TOP_UP: 'BOOST_OR_TOP_UP',
};
